<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <i class="iconfont icon-lianjie"></i>
        <span>您的邀请链接</span>
        <common-button style="float: right" size="default" :loading="saveLoading" type="primary" image @click="inviteExpireTime('ruleForm')">生成邀请码</common-button>
      </div>
      <div class="text item">
        <el-table
          row-class-name="vertical-align-top"
          @sort-change="sortChange"
          :data="groupCodeData"
          style="width: 100%"
          :default-sort="{prop: 'date', order: 'descending'}">
          <el-table-column
            prop="groupId"
            label="组号"
            sortable>
          </el-table-column>
          <el-table-column
            width="150"
            prop="groupCount"
            label="邀请码总数"
            sortable>
          </el-table-column>
          <el-table-column
            width="180"
            prop="createTime"
            label="创建时间"
            sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | datetimeFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            prop="expireTime"
            label="过期时间">
            <template slot-scope="scope">
              <span v-if="!scope.row.expireTime">永不过期</span>
              <span v-if="scope.row.expireTime">{{ scope.row.expireTime | datetimeFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            width="150"
            label="操作">
            <template slot-scope="scope">
              <button class="eims-button eims-button--text" @click="handleView(scope.$index, scope.row)">查看详情</button>
              <button class="eims-button eims-button--text" @click="handleDelete(scope.$index, scope.row)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog
      :visible.sync="showSaveVisible"
      width="30%">
      <span>确定删除邀请码 <b>{{ inviteCode.code }}</b>？</span>
      <span slot="footer" class="dialog-footer">
        <common-button @click="showSaveVisible = false" type="cancel">取 消</common-button>
        <common-button type="primary" @click="sureSavePassword" :loading="saveLoading">确 定</common-button>
      </span>
    </el-dialog>

    <common-dialog
      title="生成邀请码"
      :visible.sync="showGenerateVisible"
      width="500px">
      <span>
          <div style="width: 100%;text-align: left;padding-left: 40px">
         <div>

          <label>
            总数：
            <input id="invite-code-input" :title="inviteCode.count" type="range" v-model="inviteCode.count" min="0"
                   max="1000" step="1"/>
          </label>
            <el-input-number placeholder="输入总数"
                             size="mini"
                             :min="1"
                             :max="1000"
                             type="text-input"
                             :controls="false"
                             v-model="inviteCode.count"
                             style="width: 100px"
            />
         </div>
         <br>
         <div style="width: 100%">
               有效期：
               <el-radio-group v-model="inviteCode.period">
                <el-radio :label="1">1 天</el-radio>
                <el-radio :label="3">3天</el-radio>
                <el-radio :label="7">7天</el-radio>
                <el-radio :label="0">永不过期</el-radio>
              </el-radio-group>
         </div>
       </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <common-button @click="showGenerateVisible = false" type="cancel">取 消</common-button>
        <common-button type="primary" @click="generateInviteCode" :loading="saveLoading">确 定</common-button>
      </span>
    </common-dialog>

    <animation :loadingDataVisible="saveLoading" :loadingText="loadingText"/>
  </div>
</template>

<script>
import animation from "@/components/loading/animation"
import {uCenterPwdRule} from '@/constants/constantRules'
import {Message} from "element-ui";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {formatDatetime} from "@/utils/dateUtil";

export default {
  name: "Invite",
  props: ['uCenterData'],
  components:{animation},
  data() {
    return {
      //显示提示用户操作
      showSaveVisible: false,
      showGenerateVisible: false,
      uCenterPwdRule: uCenterPwdRule,
      //按钮设置加载中
      saveLoading: false,
      loadingText: '生成中',
      //父组件传过来的数据
      uCenter: this.uCenterData,
      groupCodeData: [],
      group: {
        groupId: 0,
        groupCount: 0,
        createTime: "",
        expireTime: "",
      },
      inviteCode: {
        id: "",
        code: "",
        userId: "",
        period: 1,
        createTime: "",
        expireTime: "",
        count: 1,
        groupId: "",
      }
    }
  },

  mounted() {
    this.initData()
  },
  methods: {

    //sortable="custom" 使得排序点击走此方
    sortChange(val) {
      let result = [];
      let dataCurr = JSON.parse(JSON.stringify(this.groupCodeData));
      if (val.order === 'ascending') {
        if (val.prop === 'expireTime') {
          dataCurr.sort((x, y) => x.expireTime.localeCompare(y.expireTime))
        }
      } else if (val.order === 'descending') {
        if (val.prop === 'expireTime') {
          dataCurr.sort((x, y) => y.expireTime.localeCompare(x.expireTime))
        }
      }
      result = JSON.parse(JSON.stringify(dataCurr));
      this.groupCodeData = result;
    },

    handleView(index, row) {
      this.$router.push({
        path: "/uCenter/inviteList",
        query: {group: row.groupId}
      })

    },
    handleDelete(index, row) {
      this.inviteCode = row
      this.showSaveVisible = true
    },

    //初始化数据
    initData() {
      this.loadingText = '读取中'
      this.saveLoading = true
      http.post(window.config.api.baseUrl + '/eims-api/inviteCode/groupInvite', {
        token: cookie.getCookie("token"),
        data: {}
      }).then(response => {
        if (response.data.code === '00000'&&null!=response.data.data) {
          this.groupCodeData = response.data.data.userInviteCodes
        }
      }).finally(() => {
        this.saveLoading = false
      })
    },

    formatter(dateTime) {
      return formatDatetime(dateTime);
    },

    //设置过期时间
    inviteExpireTime() {
      this.showGenerateVisible = true
    },

    generateInviteCode() {
      this.loadingText = this.$options.data().loadingText
      this.saveLoading = true
      let token = cookie.getCookie("token");
      http.post(window.config.api.baseUrl + '/eims-api/inviteCode/invite', {
        token: token,
        data: {
          period: this.inviteCode.period,
          count: this.inviteCode.count
        }
      }).then(response => {
        if (response.data.code === '00000') {
          this.initData()
          Message.success({message: "邀请码生成成功！", showClose: true})
        }
      }).finally(() => {
        this.saveLoading = false
        this.showGenerateVisible = false
      });
    },

    sureSavePassword() {
      this.loadingText = '删除中'
      this.saveLoading = true
      let token = cookie.getCookie("token");
      http.post(window.config.api.baseUrl + '/eims-api/inviteCode/delete', {
        token: token,
        data: {
          groupId: this.inviteCode.groupId
        }
      }).then(response => {
        if (response.data.code === '00000') {
          this.initData()
          Message.success({message: "邀请码删除成功！", showClose: true})
        }
      }).finally(() => {
        this.saveLoading = false
        this.showSaveVisible = false
      });
    },

    clearInfo() {


    }
  }
}
</script>

<style scoped>
/*将el-card的边框去掉*/
/deep/ .el-card {
  border: 0px;
  border-radius: 10px;
}

.invite-code-input {
  background-color: #5ed5d9;
}

input[type=range] {
  box-shadow: #57B3D7 1px 1px 10px;
  margin-top: 8px; /*上部分的填充值*/
  outline: none;
  -webkit-appearance: none; /*清除系统默认样式*/
  width: 220px;
  background: -webkit-linear-gradient(left, #fad9d9, #ffa5a5) no-repeat, #0a6eff; /*背景颜色，俩个颜色分别对应上下，自己尝试下就知道了嗯*/
  /*background-size: 33% 100%;!*设置左右宽度比例*!*/
  height: 10px; /*横条的高度，细的真的比较好看嗯*/
  border-radius: 10px;
}

/*拖动块的样式*/
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none; /*清除系统默认样式*/
  height: 16px; /*拖动块高度*/
  width: 16px; /*拖动块宽度*/
  background: #faf9f8; /*拖动块背景*/
  border-radius: 50%; /*外观设置为圆形*/
  border: solid 1px #ddd; /*设置边框*/
}

</style>



// WEBPACK FOOTER //
// src/pages/user/GroupInvite.vue